import type JSZip from 'jszip';

// mammoth never reads header/footer parts, so anything in them vanishes silently;
// detect real content straight from the archive so the import can warn about the loss
const PAGE_BOILERPLATE = /^(?:page|of|\d+|[\s\-–—/])*$/i;

const MEDIA_ELEMENT = /<w:drawing|<w:pict|<w:object/;

const visibleText = (xml: string): string =>
  [...xml.replace(/<w:instrText[\s\S]*?<\/w:instrText>/g, '').matchAll(/<w:t[^>]*>([^<]*)<\/w:t>/g)]
    .map((match) => match[1])
    .join(' ');

export const hasHeaderFooterContent = async (zipArchive: Promise<JSZip>): Promise<boolean> => {
  const zip = await zipArchive;
  const parts = Object.keys(zip.files).filter((name) => /^word\/(?:header|footer)\d*\.xml$/.test(name));

  for (const name of parts) {
    const xml = await zip.file(name)!.async('string');

    if (MEDIA_ELEMENT.test(xml) || !PAGE_BOILERPLATE.test(visibleText(xml).trim())) {
      return true;
    }
  }

  return false;
};
